// src/pages/PortalSaaS/modules/ChatEspecialista.js
import React, { useState, useEffect, useRef } from 'react';
import { useOutletContext, useNavigate} from 'react-router-dom';
import { httpsCallable } from 'firebase/functions';
import { db, functions, storage } from '../../../firebase'; // <-- Adicionado Storage
import { collection, query, where, orderBy, onSnapshot, doc, getDoc, updateDoc } from 'firebase/firestore';
import { ref, uploadBytesResumable } from 'firebase/storage'; // <-- Adicionado
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm'
import { BsThreeDotsVertical, BsPinAngleFill, BsPencilFill, BsTrashFill } from "react-icons/bs";
import { useAuth } from '../../../context/AuthContext';


const menuItemStyle = {
    padding: '12px 15px',
    fontSize: '0.85rem',
    cursor: 'pointer',
    borderBottom: '1px solid #f1f5f9',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    transition: 'background 0.2s',
    backgroundColor: '#fff'
};

const ChatEspecialista = () => {
    const { workspaceData } = useOutletContext();
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const cnpj = workspaceData?.cnpj_completo;
    const workspaceId = workspaceData?._id;
    const uid = currentUser?.uid;
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    // NOVOS ESTADOS PARA O MENU DO HISTÓRICO
    const [activeMenuId, setActiveMenuId] = useState(null);
    const [editingChatId, setEditingChatId] = useState(null);
    const [newChatTitle, setNewChatTitle] = useState("");
    
    // GESTÃO DE SESSÃO E RAG
    const [sessions, setSessions] = useState([]);
    const [currentSessionId, setCurrentSessionId] = useState(null);
    const [activeFiles, setActiveFiles] = useState([]); // <-- Guarda os arquivos anexados no chat
    const [uploadProgress, setUploadProgress] = useState(0); // <-- Barra de progresso de envio

    // GESTÃO DE ÁUDIO (VOICE-TO-TEXT)
    const [isRecording, setIsRecording] = useState(false);
    const mediaRecorderRef = useRef(null);
    const audioChunksRef = useRef([]);
    
    // GESTÃO FINANCEIRA E LOJA DE TOKENS
    const [saldoTokens, setSaldoTokens] = useState(workspaceData.config_ia?.saldoInteracoesIA || 0);
    const [autoRecharge, setAutoRecharge] = useState(workspaceData.config_ia?.autoRecharge || false);
    const [showStoreModal, setShowStoreModal] = useState(false);
    const [pixData, setPixData] = useState(null); 
    const [isBuying, setIsBuying] = useState(false);
    const [showSettingsMenu, setShowSettingsMenu] = useState(false); // NOVO: Controle do menu suspenso

    const isPF = workspaceData.tipo === 'PF';
    const messagesEndRef = useRef(null);

    // 1. ESCUTA O HISTÓRICO DE CONVERSAS E SALDO (BLINDADO) E RBAC
    useEffect(() => {
        if (!workspaceData) return;

        // --- TRAVA DE SEGURANÇA (ISOLAMENTO COGNITIVO) ---
        // O Chat Especialista é o Cérebro de Negócios. Apenas Gestão acessa.
        // O Laboratorista (USER) usa a IA de forma passiva na Central de Ensaios.
        // O Cliente (EXTRANET) jamais pode acessar a inteligência do Laboratório.
        if (workspaceData.role === 'USER' || workspaceData.role === 'EXTRANET') {
            alert("Acesso Negado: O Departamento de IA Conversacional é restrito a Sócios e Gerentes.");
            navigate(`/${workspaceData.slug}/dashboard`);
            return;
        }

        // Trava de segurança: Se não houver dados, não abre conexão com o banco.
        if (!cnpj && !workspaceId) return;

        const currentWkspId = cnpj || workspaceId;

        // Escuta 1: Saldo Financeiro
        const wkspRef = doc(db, "workspaces", currentWkspId);
        const unsubWksp = onSnapshot(wkspRef, (docSnap) => {
            if (docSnap.exists()) {
                const novoSaldo = docSnap.data().config_ia?.saldoInteracoesIA;
                if (novoSaldo !== undefined) setSaldoTokens(novoSaldo);
            }
        }, (error) => {
            console.error("Erro na escuta de saldo:", error);
        });
        // --- MUDANÇA NÍVEL A: Lendo a "Gaveta" do Workspace filtrada pelo UID ---
        const sessoesRef = collection(db, "workspaces", currentWkspId, "sessoes_chat");
        const q = query(
            sessoesRef,
            where("usuario_uid", "==", uid), // Isolamento Local do Funcionário
            orderBy("updatedAt", "desc")
        );
        
        const unsubChat = onSnapshot(q, (snapshot) => {
            const sessionsList = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setSessions(sessionsList);
        });

        // Função de limpeza rigorosa ao desmontar o componente
        return () => { unsubWksp(); unsubChat(); };
    }, [cnpj, workspaceId, uid, workspaceData, navigate]);
    // ^ CRÍTICO: O array de dependência mudou. Ele não escuta mais o objeto inteiro, 
    // apenas os IDs. Isso impede que o túnel feche e abra infinitamente.

    // 2. CARREGA MENSAGENS (ARQUITETURA ATÔMICA)
    const loadSession = async (sessionId) => {
        setCurrentSessionId(sessionId);
        const docRef = doc(db, "workspaces", workspaceData.cnpj_completo, "sessoes_chat", sessionId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            const data = docSnap.data();
            setMessages(data.history.map(h => ({
                role: h.role === 'user' ? 'user' : 'ai',
                text: h.parts[0].text
            })));
            setActiveFiles(data.attachedFiles || []);
        }
    };

    const startNewChat = () => {
        setCurrentSessionId(null);
        setActiveFiles([]); 
        setMessages([{ role: 'ai', text: `Nova sessão iniciada. Como posso ajudar no suporte técnico agora?` }]);
    };

    // --- LÓGICA DE GRAVAÇÃO DE ÁUDIO (VOICE-TO-TEXT) ---
    const startRecording = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            const mediaRecorder = new MediaRecorder(stream);
            mediaRecorderRef.current = mediaRecorder;
            audioChunksRef.current = [];

            mediaRecorder.ondataavailable = (event) => {
                if (event.data.size > 0) audioChunksRef.current.push(event.data);
            };

            mediaRecorder.onstop = async () => {
                const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
                const reader = new FileReader();
                reader.readAsDataURL(audioBlob);
                reader.onloadend = async () => {
                    const base64Audio = reader.result;
                    setIsLoading(true);
                    try {
                        const transcreverFn = httpsCallable(functions, 'transcreverAudioPTS');
                        const response = await transcreverFn({
                            audioBase64: base64Audio,
                            mimeType: 'audio/webm',
                            workspaceId: workspaceData.cnpj_completo || workspaceData._id
                        });
                        
                        // Joga o texto transcrito no input do usuário e atualiza a interface
                        setInput(prev => prev ? `${prev} ${response.data.texto}` : response.data.texto);
                        setSaldoTokens(prev => prev - response.data.custoAplicado);
                    } catch (error) {
                        alert("Falha ao transcrever o áudio.");
                        console.error(error);
                    } finally {
                        setIsLoading(false);
                    }
                };
                
                // Desliga o microfone do navegador para não ficar com a luz vermelha acesa
                stream.getTracks().forEach(track => track.stop());
            };

            mediaRecorder.start();
            setIsRecording(true);
        } catch (error) {
            alert("Não foi possível acessar o microfone. Verifique as permissões do navegador.");
        }
    };

    const stopRecording = () => {
        if (mediaRecorderRef.current && isRecording) {
            mediaRecorderRef.current.stop();
            setIsRecording(false);
        }
    };

    // --- UPLOAD RAG MULTIMODAL (PRÉ-ALOCAÇÃO DE ID) ---
    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        if (isPF && activeFiles.length >= 5) {
            return alert("Limite atingido. O Plano Acadêmico permite até 5 arquivos no contexto.");
        }

        try {
            // O Segredo: Se não há sessão aberta, nós "prevemos" o ID gerando um documento vazio
            let sessionIdToUse = currentSessionId;
            if (!sessionIdToUse) {
                const newDocRef = doc(collection(db, "workspaces", workspaceData.cnpj_completo, "sessoes_chat"));
                sessionIdToUse = newDocRef.id;
                setCurrentSessionId(sessionIdToUse); // Força a tela a assumir este ID
            }

            const uniqueName = `${Date.now()}_${file.name.replace(/[^a-zA-Z0-9.]/g, "_")}`;
            // Nova Rota: uploads_clientes / cnpj / chat_ia / ID_DA_SESSAO / arquivo.pdf
            const storagePath = `uploads_clientes/${workspaceData.cnpj_completo}/chat_ia/${sessionIdToUse}/${uniqueName}`;
            const storageRef = ref(storage, storagePath);

            const uploadTask = uploadBytesResumable(storageRef, file);

            uploadTask.on('state_changed', 
                (snapshot) => setUploadProgress((snapshot.bytesTransferred / snapshot.totalBytes) * 100), 
                (error) => {
                    console.error("Falha no upload:", error);
                    alert("Erro ao enviar arquivo.");
                    setUploadProgress(0);
                }, 
                async () => {
                    const gsUri = `gs://${storage.app.options.storageBucket}/${storagePath}`;
                    setActiveFiles(prev => [...prev, { name: file.name, uri: gsUri, mimeType: file.type }]);
                    setUploadProgress(0);
                }
            );
        } catch (e) {
            console.error(e);
            setUploadProgress(0);
        }
    };

    const removeFile = async (uriToRemove) => {
        try {
            // Avisa o servidor primeiro
            const apagarArquivoFn = httpsCallable(functions, 'apagarArquivoIA');
            const result = await apagarArquivoFn({ 
                fileUri: uriToRemove, 
                workspaceId: workspaceData.cnpj_completo 
            });

            // Só remove da tela se o servidor confirmar que apagou lá da nuvem
            if (result.data.status === "SUCCESS") {
                setActiveFiles(prev => prev.filter(f => f.uri !== uriToRemove));
                alert("Arquivo apagado"); // O alerta que você exigiu
            } else {
                console.error("Servidor recusou exclusão:", result.data.reason);
                alert("O arquivo já foi apagado ou não pôde ser removido.");
                // Limpa da tela mesmo assim, pois o arquivo não existe mais
                setActiveFiles(prev => prev.filter(f => f.uri !== uriToRemove));
            }

        } catch (error) {
            console.error("Erro ao solicitar exclusão ao servidor:", error);
            alert("Erro de conexão ao tentar apagar o arquivo.");
        }
    };

    // 3. ENVIO DE MENSAGEM (Com Contexto RAG)
    const handleSendMessage = async (e) => {
        if (e) e.preventDefault();
        if (!input.trim() && activeFiles.length === 0) return; // Alterado para não bloquear se houver arquivo
        if (isLoading) return;

        const userMsg = input;
        setInput('');
        setMessages(prev => [...prev, { role: 'user', text: userMsg }]);
        setIsLoading(true);
        setTimeout(() => {
            messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
        }, 100);

        try {
            const chatFn = httpsCallable(functions, 'chatComEspecialista');
            const result = await chatFn({
                sessionId: currentSessionId,
                message: userMsg,
                workspaceId: workspaceData.cnpj_completo || workspaceData._id,
                cnpjRaiz: workspaceData.cnpj_raiz, 
                contextFiles: activeFiles 
            });

            if (result.data.status === "INSUFFICIENT_FUNDS") {
                setMessages(prev => [...prev, { role: 'ai', text: result.data.reply }]);
            } else {
                setMessages(prev => [...prev, { role: 'ai', text: result.data.reply }]);
                if (!currentSessionId) setCurrentSessionId(result.data.sessionId);
                
                // --- CORREÇÃO: O Saldo agora é ATUALIZADO AUTOMATICAMENTE PELO FIREBASE. ---
                // Removemos o 'setSaldoTokens(prev => prev - gasto)' daqui.
                // O useEffect com onSnapshot já cuida de puxar o saldo exato (8775.73) do banco.
            }

        } catch (error) {
            alert("Erro na conexão com o Chat Perito Digital.");
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const toggleAutoRecharge = async (checked) => {
        setAutoRecharge(checked);
        try {
            const wkspRef = doc(db, "workspaces", workspaceData.cnpj_completo || workspaceData._id);
            await updateDoc(wkspRef, { "config_ia.autoRecharge": checked });
        } catch (e) {
            setAutoRecharge(!checked); 
        }
    };

    const comprarPacote = async (sku) => {
        setIsBuying(true);
        setPixData(null);
        try {
            const comprarFn = httpsCallable(functions, 'comprarCreditosIA');
            const response = await comprarFn({
                workspaceId: workspaceData.cnpj_completo || workspaceData._id,
                pacoteSku: sku,
                metodoPagamento: "PIX"
            });
            setPixData(response.data);
        } catch (e) {
            alert("Falha ao gerar cobrança.");
        } finally {
            setIsBuying(false);
        }
    };
    // --- FUNÇÕES DO MENU DE GESTÃO ---
    
    const handlePin = async (chat) => {
        setActiveMenuId(null);
        const docRef = doc(db, "workspaces", workspaceData.cnpj_completo, "sessoes_chat", chat.id);
        await updateDoc(docRef, { isPinned: !chat.isPinned });
    };

    const handleDelete = async (chat) => {
        if(window.confirm("Deseja excluir este chat permanentemente? Todos os arquivos anexados a ele também serão apagados do servidor.")) {
            setActiveMenuId(null);
            if(currentSessionId === chat.id) startNewChat();
            
            try {
                const deletarChatFn = httpsCallable(functions, 'deletarSessaoChatIA');
                await deletarChatFn({
                    sessionId: chat.id,
                    workspaceId: workspaceData.cnpj_completo
                });
            } catch (e) {
                alert("Falha ao limpar os dados do servidor.");
            }
        }
    };

    const saveRename = async (chatId) => {
        if(newChatTitle.trim()) {
            const docRef = doc(db, "workspaces", workspaceData.cnpj_completo, "sessoes_chat", chatId);
            await updateDoc(docRef, { titulo: newChatTitle.trim() });
        }
        setEditingChatId(null);
    };

    return (
        // MUDANÇA 1: Grid de 2 colunas (260px 1fr) em vez de 3
<div className="pts-chat-layout" style={{ display: 'grid', gridTemplateColumns: '260px 1fr', gap: '0', height: '100%', minHeight: '500px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '16px', overflow: 'hidden', position: 'relative' }}>            
            {/* MODAL DE LOJA MANTIDA INTACTA */}
            {showStoreModal && (
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15,23,42,0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50 }}>
                    <div style={{ background: '#fff', padding: '30px', borderRadius: '16px', width: '400px', textAlign: 'center' }}>
                        <h3 style={{ margin: '0 0 20px 0' }}>🛒 Recarga de Tokens IA</h3>
                        
                        {!pixData ? (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                                <button className="pts-btn-outline" onClick={() => comprarPacote("TOKENS_10K")} disabled={isBuying}>
                                    {isBuying ? "Gerando..." : "10.000 Tokens (R$ 25,00)"}
                                </button>
                                <button className="pts-btn-launch" onClick={() => comprarPacote("TOKENS_50K")} disabled={isBuying}>
                                    {isBuying ? "Gerando..." : "50.000 Tokens (R$ 70,00)"}
                                </button>
                                <button style={{ marginTop: '10px', background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer' }} onClick={() => setShowStoreModal(false)}>
                                    Cancelar
                                </button>
                            </div>
                        ) : (
                            <div>
                                <p style={{ fontSize: '0.9rem', color: '#10b981', fontWeight: 'bold' }}>PIX Gerado com Sucesso!</p>
                                <img src={`data:image/png;base64,${pixData.qrCodeImage}`} alt="QR Code PIX" style={{ width: '200px', height: '200px', margin: '15px 0' }} />
                                <p style={{ fontSize: '0.75rem', background: '#f1f5f9', padding: '10px', borderRadius: '8px', wordBreak: 'break-all' }}>
                                    {pixData.qrCode}
                                </p>
                                <p style={{ fontSize: '0.8rem', color: '#64748b' }}>Os tokens entrarão automaticamente assim que o pagamento for processado pelo banco.</p>
                                <button className="pts-btn-outline" style={{ marginTop: '15px' }} onClick={() => setShowStoreModal(false)}>Fechar Janela</button>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* COLUNA ESQUERDA: HISTÓRICO E CONFIGURAÇÕES */}
            <aside style={{ background: '#1e293b', color: '#fff', padding: '20px', display: 'flex', flexDirection: 'column', position: 'relative' }}>
                <button onClick={startNewChat} className="pts-btn-primary" style={{ width: '100%', marginBottom: '20px', background: '#38bdf8', color: '#0f172a' }}>
                    + Novo Chat
                </button>
                <div style={{ flexGrow: 1, overflowY: 'auto' }}>
                    <small style={{ color: '#94a3b8', textTransform: 'uppercase', fontSize: '0.65rem', letterSpacing: '1px' }}>Histórico Recente</small>
                    <div style={{ marginTop: '10px' }}>
                        {sessions
                            .filter(s => !s.deleted)
                            .sort((a, b) => (b.isPinned ? 1 : 0) - (a.isPinned ? 1 : 0))
                            .map(s => (
                                <div key={s.id} style={{ position: 'relative', marginBottom: '5px' }}>
                                    <div 
                                        onClick={() => { if(editingChatId !== s.id) loadSession(s.id); }}
                                        style={{ 
                                            padding: '10px 35px 10px 10px', 
                                            borderRadius: '8px', 
                                            cursor: 'pointer', 
                                            fontSize: '0.85rem', 
                                            background: currentSessionId === s.id ? '#334155' : 'transparent',
                                            borderLeft: s.isPinned ? '4px solid #38bdf8' : 'none',
                                            display: 'flex', 
                                            alignItems: 'center',
                                            transition: 'background 0.2s'
                                        }}
                                    >
                                        <span style={{ flexGrow: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#f1f5f9' }}>
                                            {editingChatId === s.id ? (
                                                <input 
                                                    autoFocus 
                                                    value={newChatTitle} 
                                                    onChange={(e) => setNewChatTitle(e.target.value)}
                                                    onBlur={() => saveRename(s.id)} 
                                                    onKeyDown={(e) => e.key === 'Enter' && saveRename(s.id)}
                                                    style={{ width: '100%', background: '#0f172a', color: '#fff', border: '1px solid #38bdf8', borderRadius: '4px', padding: '2px 5px' }}
                                                />
                                            ) : (
                                                <>{s.isPinned ? '📌 ' : '💬 '} {s.titulo || "Conversa sem título"}</>
                                            )}
                                        </span>
                                        
                                        <div 
                                            onClick={(e) => { 
                                                e.stopPropagation(); 
                                                setActiveMenuId(activeMenuId === s.id ? null : s.id); 
                                            }}
                                            style={{ position: 'absolute', right: '8px', padding: '4px', cursor: 'pointer', color: '#94a3b8', display: 'flex' }}
                                        >
                                            <BsThreeDotsVertical />
                                        </div>
                                    </div>

                                    {activeMenuId === s.id && (
                                        <div style={{ position: 'absolute', right: '0', top: '40px', background: '#fff', color: '#1e293b', borderRadius: '12px', boxShadow: '0 10px 25px rgba(0,0,0,0.2)', zIndex: 100, width: '180px', overflow: 'hidden', border: '1px solid #e2e8f0' }}>
                                            <div onClick={(e) => { e.stopPropagation(); handlePin(s); }} style={menuItemStyle} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8fafc'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}>
                                                <BsPinAngleFill size={14}/> {s.isPinned ? "Desfixar" : "Fixar no Topo"}
                                            </div>
                                            <div onClick={(e) => { e.stopPropagation(); setEditingChatId(s.id); setNewChatTitle(s.titulo || ""); setActiveMenuId(null); }} style={menuItemStyle} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8fafc'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}>
                                                <BsPencilFill size={14}/> Renomear
                                            </div>
                                            <div onClick={(e) => { e.stopPropagation(); handleDelete(s); }} style={{ ...menuItemStyle, color: '#ef4444', borderBottom: 'none' }} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#fef2f2'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}>
                                                <BsTrashFill size={14}/> Excluir
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                    </div>
                </div>

                {/* MUDANÇA 2: MENU SUSPENSO DE CONFIGURAÇÕES (O NOVO LAR DA COLUNA DIREITA) */}
                <div style={{ marginTop: 'auto', borderTop: '1px solid #334155', paddingTop: '15px', position: 'relative' }}>
                    
                    {/* Botão Gatilho (Engrenagem) */}
                    <button 
                        onClick={() => setShowSettingsMenu(!showSettingsMenu)}
                        style={{ background: 'none', border: 'none', color: '#cbd5e1', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '10px', width: '100%', fontSize: '0.9rem', padding: '5px 0' }}
                    >
                        ⚙️ Contexto e Energia {activeFiles.length > 0 && <span style={{background: '#38bdf8', color: '#0f172a', borderRadius: '50%', padding: '2px 6px', fontSize: '0.7rem', fontWeight: 'bold'}}>{activeFiles.length}</span>}
                    </button>

                    {/* O Menu em si */}
                    {showSettingsMenu && (
                        <div style={{
                            position: 'absolute', bottom: '100%', left: '0', width: '320px', background: '#fff', borderRadius: '12px', padding: '20px', boxShadow: '0 -10px 25px rgba(0,0,0,0.1)', color: '#0f172a', zIndex: 100, marginBottom: '15px', border: '1px solid #e2e8f0', maxHeight: '65vh', overflowY: 'auto'
                        }}>
                            
                            {/* BLOCO: ENERGIA (Único lugar onde aparece a contagem de Tokens) */}
                            <div style={{ marginBottom: '20px', paddingBottom: '15px', borderBottom: '1px solid #e2e8f0' }}>
                                <h4 style={{ margin: '0 0 10px 0', fontSize: '0.95rem', color: '#0f172a' }}>⚙️ Gestão de Energia</h4>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', background: '#f8fafc', padding: '10px', borderRadius: '8px' }}>
                                    <span style={{ fontSize: '0.75rem', color: '#64748b' }}>SALDO DISPONÍVEL</span>
                                    <strong style={{ color: saldoTokens < 500 ? '#ef4444' : '#10b981', fontSize: '1rem' }}>
                                        ⚡ {Number(saldoTokens).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </strong>
                                </div>

                                {['OWNER', 'MANAGER'].includes(workspaceData.role) && (
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px', alignItems: 'center' }}>
                                        <span style={{ fontSize: '0.8rem', color: '#475569' }}>Recarga Automática</span>
                                        <input type="checkbox" checked={autoRecharge} onChange={(e) => toggleAutoRecharge(e.target.checked)} style={{ cursor: 'pointer' }} />
                                    </div>
                                )}
                                
                                <button className="pts-btn-outline" onClick={() => { setShowSettingsMenu(false); setShowStoreModal(true); }} style={{ width: '100%', fontSize: '0.8rem', padding: '8px' }}>
                                    🛒 Comprar Créditos
                                </button>
                            </div>

                            
                        </div>
                    )}
                </div>
            </aside>

            {/* COLUNA DIREITA: A ÁREA DE CHAT (Agora ocupa todo o espaço restante) */}
            <div style={{ display: 'flex', flexDirection: 'column', background: '#fff' }}>
                <header style={{ padding: '20px', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3 style={{ margin: 0, fontSize: '1.1rem', color: '#0f172a' }}>🤖 Chat IA PTS</h3>
                    {/* MUDANÇA 3: Contador de tokens removido do header */}
                </header>

                <div style={{ flexGrow: 1, height: 0, padding: '30px', overflowY: 'auto', background: '#f8fafc' }}>
                    {messages.map((m, i) => (
                        <div key={i} style={{ marginBottom: '20px', display: 'flex', justifyContent: m.role === 'user' ? 'flex-end' : 'flex-start' }}>
                            <div 
                                    onCopy={(e) => {
                                        if (m.role !== 'user') {
                                            e.preventDefault();
                                            // Se ele forçar cópia (via extensão/teclado), cola isso na área de transferência dele:
                                            if (e.clipboardData) {
                                                e.clipboardData.setData('text/plain', 'Acesso Restrito: Utilize os Agentes Especialistas da PTS DEV para obter memórias de cálculo rastreáveis e oficiais.');
                                            }
                                        }
                                    }}
                                    style={{ 
                                        padding: '15px 20px', 
                                        borderRadius: '16px',
                                        maxWidth: '80%',
                                        fontSize: '0.95rem',
                                        lineHeight: '1.5',
                                        boxShadow: '0 2px 5px rgba(0,0,0,0.02)',
                                        background: m.role === 'user' ? '#0f172a' : '#fff',
                                        color: m.role === 'user' ? '#fff' : '#334155',
                                        border: m.role === 'user' ? 'none' : '1px solid #e2e8f0',
                                        overflowWrap: 'break-word',
                                        // O ESCUDO ANTI-SELEÇÃO: Apenas na IA
                                        userSelect: m.role === 'user' ? 'auto' : 'none',
                                        WebkitUserSelect: m.role === 'user' ? 'auto' : 'none',
                                        MozUserSelect: m.role === 'user' ? 'auto' : 'none'
                                    }}>
                                    {m.role === 'user' ? (
                                        m.text
                                    ) : (
                                        <ReactMarkdown remarkPlugins={[remarkGfm]} components={{
                                            p: ({node, ...props}) => <p style={{margin: '0 0 10px 0'}} {...props} />,
                                            ul: ({node, ...props}) => <ul style={{margin: '0 0 10px 0', paddingLeft: '20px'}} {...props} />,
                                            li: ({node, ...props}) => <li style={{marginBottom: '5px'}} {...props} />
                                        }}>
                                            {m.text}
                                        </ReactMarkdown>
                                    )}
                                </div>
                        </div>
                    ))}
                    {isLoading && <div style={{ color: '#94a3b8', fontSize: '0.8rem', textAlign: 'right' }}>Processando...</div>}
                    <div ref={messagesEndRef} />
                </div>

                {/* --- A NOVA ILHA MULTIMODAL --- */}
                <div style={{ padding: '20px', borderTop: '1px solid #f1f5f9', background: '#fff' }}>
                    <form 
                        onSubmit={handleSendMessage} 
                        style={{ 
                            display: 'flex', flexDirection: 'column', 
                            background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '16px', 
                            padding: '10px', transition: 'border 0.2s',
                            boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.02)'
                        }}
                    >
                        {/* ZONA DE CONTEXTO (Aparece apenas se houver arquivos) */}
                        {activeFiles.length > 0 && (
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', padding: '5px 10px 15px 10px', borderBottom: '1px dashed #e2e8f0', marginBottom: '10px' }}>
                                {activeFiles.map((file, idx) => (
                                    <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '8px', background: '#fff', border: '1px solid #cbd5e1', padding: '6px 12px', borderRadius: '50px', fontSize: '0.75rem', color: '#334155', boxShadow: '0 2px 5px rgba(0,0,0,0.02)' }}>
                                        <span style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>📄 {file.name}</span>
                                        <button type="button" onClick={() => removeFile(file.uri)} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2px' }} title="Excluir arquivo do servidor">✕</button>
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* ZONA DE INPUT E AÇÕES */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            
                            

                            {/* CAMPO DE TEXTO INVISÍVEL */}
                            <input 
                                className="pts-dynamic-input" name="chatInput"
                                style={{ margin: 0, flexGrow: 1, background: 'transparent', border: 'none', boxShadow: 'none', padding: '5px' }} 
                                placeholder={isRecording ? "Ouvindo..." : "Digite sua dúvida técnica ou anexe um ensaio..."}
                                value={input}
                                onChange={(e) => setInput(e.target.value)}
                                disabled={isLoading || uploadProgress > 0}
                            />

                            {/* CLIPE DE PAPEL (UPLOAD) */}
                            <div style={{ position: 'relative' }}>
                                <input type="file" id="chat-file-upload" hidden onChange={handleFileUpload} disabled={uploadProgress > 0} />
                                <label 
                                    htmlFor="chat-file-upload" 
                                    style={{ padding: '10px', cursor: uploadProgress > 0 ? 'not-allowed' : 'pointer', color: '#64748b', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '8px', transition: 'all 0.2s' }}
                                    title="Anexar PDF, Foto ou CSV"
                                    onMouseOver={e => { e.currentTarget.style.background = '#e2e8f0'; e.currentTarget.style.color = '#0f172a'; }}
                                    onMouseOut={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#64748b'; }}
                                >
                                    {uploadProgress > 0 ? `${Math.round(uploadProgress)}%` : '📎'}
                                </label>
                            </div>
                            {/* MICROFONE */}
                            <button 
                                type="button" onMouseDown={startRecording} onMouseUp={stopRecording} onTouchStart={startRecording} onTouchEnd={stopRecording} 
                                disabled={isLoading || uploadProgress > 0}
                                style={{ padding: '10px', borderRadius: '50%', border: 'none', background: isRecording ? '#ef4444' : 'transparent', color: isRecording ? '#fff' : '#64748b', cursor: 'pointer', transition: 'all 0.2s', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                title="Segure para falar"
                            >
                                🎤
                            </button>
                            {/* BOTÃO ENVIAR */}
                            <button type="submit" className="pts-btn-primary" disabled={isLoading || (!input.trim() && activeFiles.length === 0) || uploadProgress > 0} style={{ padding: '10px 20px', borderRadius: '12px' }}>
                                Enviar
                            </button>
                        </div>
                    </form>
                    
                    {/* ALERTA ACADÊMICO FLUTUANTE */}
                    {isPF && activeFiles.length >= 5 && (
                        <p style={{ fontSize: '0.7rem', color: '#b45309', margin: '5px 0 0 0', textAlign: 'right' }}>⚠️ Limite do Plano Acadêmico atingido (5/5 arquivos).</p>
                    )}

                    {/* AVISO LEGAL E DE RESPONSABILIDADE (DISCLAIMER) */}
                    <div style={{ textAlign: 'center', marginTop: '12px' }}>
                        <p style={{ fontSize: '0.65rem', color: '#94a3b8', margin: 0 }}>
                            A <strong>IA do Asfalto</strong> e uma IA e pode cometer erros.
                        </p>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ChatEspecialista;